import React, {useContext, useEffect} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import {useNavigate, useParams} from 'react-router-dom';

import {Button, message, Space, Tabs} from 'antd';
import {IoArrowBackOutline} from 'react-icons/all';
import AppPageMetadata from '@crema/core/AppPageMetadata';
import AppsContainer from '@crema/core/AppsContainer';
import AppsHeader from '@crema/core/AppsContainer/AppsHeader';
import AppsContent from '@crema/core/AppsContainer/AppsContent';
import {OrganizationContext, Provider} from '../OrganizationContext';
import OrganizationInfo from './OrganizationInfo';
import {findOrganizationById} from 'services/OrganizationService';
import {handleError} from 'utils/MessageUtils';
import RoleList from './RoleList';

const DetailTab = () => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();
  const navigate = useNavigate();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const organizationContext = useContext(OrganizationContext);
  const {setSelectedOrganization} = organizationContext;

  useEffect(() => {
    if (id) {
      findOrganizationById(headers, id)
        .then((res) => {
          setSelectedOrganization(res.data);
        })
        .catch((error) => handleError(message, error));
    }
  }, [id]);

  return (
    <>
      <AppPageMetadata title={intl.messages['common.detail']} />
      <AppsContainer
        title={intl.messages['organization.info']}
        fullView
        type='bottom'>
        <AppsHeader key={'header'}>
          <div className='customer-header'>
            <div className='customer-header-input-view'>
              <Button
                type='primary'
                shape='circle'
                ghost
                icon={<IoArrowBackOutline />}
                onClick={() => navigate('/health/organizations')}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={'content'}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}>
          <Space
            direction='vertical'
            style={{width: '100%', paddingLeft: 10, paddingRight: 10}}>
            <Tabs defaultActiveKey='1' destroyInactiveTabPane={true}>
              <Tabs.TabPane tab={intl.messages['common.detail']} key='1'>
                <OrganizationInfo />
              </Tabs.TabPane>
              <Tabs.TabPane tab={intl.messages['practitioner.list']} key='2'>
                <RoleList />
              </Tabs.TabPane>
            </Tabs>
          </Space>
        </AppsContent>
      </AppsContainer>
    </>
  );
};

export default function OrganizationDetail() {
  return (
    <Provider>
      <DetailTab />
    </Provider>
  );
}
